import moment from 'moment';
import React from 'react';
import { IUser } from 'types/users';
import styles from './styles.module.scss';
import { ISession } from 'types/session';
import { formatServiceTypeTitle, formatUserFullName } from 'utils/helpers';

const date = new Date();

const SessionTable = ({ data, curDateTime }: { data: ISession; curDateTime?: Date }) => {
	return (
		<table className={styles.table}>
			<tbody>
				<tr>
					<td>
						ФИО: {formatUserFullName(data?.user)}
					</td>
				</tr>
				<tr>
					<td>Тип услуги: {formatServiceTypeTitle(data?.outsourcing?.pos ? data?.outsourcing.pos?.title : data?.outsourcing?.position)}</td>
				</tr>
				<tr>
					<td>Компания: {data?.outsourcing?.counterparty?.title}</td>
				</tr>
				{data?.outsourcing?.plannedStart && (
					<tr>
						<td>Плановые дата и время прихода: {moment(data?.outsourcing?.plannedStart).format('DD.MM.YY HH:mm')}</td>
					</tr>
				)}
				{data?.outsourcing?.plannedEnd && (
					<tr>
						<td>Плановые дата и время прихода: {moment(data?.outsourcing?.plannedEnd).format('DD.MM.YY HH:mm')}</td>
					</tr>
				)}
				{curDateTime && (
					<tr>
						<td>{moment(curDateTime).format('DD.MM.YY HH:mm')}</td>
					</tr>
				)}
			</tbody>
		</table>
	);
};

export default SessionTable;
